// frontend/src/components/ProjectDetail/panels/JournalEntryListItem.js
import React from 'react';
import { Trash2, User, Calendar } from 'lucide-react';

const JournalEntryListItem = ({ entry, onEdit, onDelete, getUsernameById, isDeleting }) => {
  // MODIFICATION : Utiliser directement entry.user_name fourni par le backend
  // L'ancien code était: const userName = getUsernameById(entry.user_id) || 'Utilisateur inconnu';
  const userName = entry.user_name || 'Utilisateur inconnu'; 
  
  const extractPlainTextFromDelta = (deltaLike) => {
    const ops = Array.isArray(deltaLike?.ops) ? deltaLike.ops : Array.isArray(deltaLike) ? deltaLike : [];
    return ops
      .map((op) => {
        if (typeof op.insert === 'string') {
          return op.insert;
        }
        if (typeof op.insert === 'object') {
          const insert = op.insert || {};
          if (insert['drive-ref']) {
            return insert['drive-ref'].name || 'Reference Drive';
          }
          if (insert['stock-tag']) {
            return insert['stock-tag'].item_name || insert['stock-tag'].serial_number || 'Stock';
          }
          if (insert['task-card']) {
            return insert['task-card'].name || 'Tache';
          }
          if (insert['journal-image']) {
            const image = insert['journal-image'];
            return ` Image : ${image.original_filename || image.name || 'visuel'} `;
          }
          if (insert.image) {
            return ' Image ';
          }
          return ' ';
        }
        return '';
      })
      .join('');
  };

  const stripHtml = (value = '') => {
    if (typeof window === 'undefined') {
      return value.replace(/<[^>]+>/g, ' ');
    }
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  const createContentPreview = (rawContent) => {
    if (!rawContent) return 'Pas de contenu.';

    if (typeof rawContent === 'object') {
      const text = extractPlainTextFromDelta(rawContent);
      return text || 'Pas de contenu.';
    }

    if (typeof rawContent === 'string') {
      const trimmed = rawContent.trim();
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try {
          const parsed = JSON.parse(trimmed);
          const textFromDelta = extractPlainTextFromDelta(parsed);
          if (textFromDelta) {
            return textFromDelta;
          }
        } catch (err) {
          // ignore JSON parse failure and fallback to HTML stripping
        }
      }
      return stripHtml(trimmed);
    }

    return String(rawContent);
  };

  const contentPreview = createContentPreview(entry.content);
  const previewText = contentPreview.length > 400 ? `${contentPreview.slice(0, 400)}...` : contentPreview;

  const entryDateObj = entry.entry_date ? new Date(entry.entry_date) : null;
  const displayDate = entryDateObj ? new Date(entryDateObj.getUTCFullYear(), entryDateObj.getUTCMonth(), entryDateObj.getUTCDate()).toLocaleDateString('fr-FR') : 'N/A';


  return (
    // MODIFICATION: Clic sur l'item déclenche onEdit
    <li 
      className={`bg-white p-3 rounded-md border border-gray-200 hover:shadow-md transition-shadow cursor-pointer h-full flex flex-col ${isDeleting === entry.id ? 'opacity-50' : ''}`}
      onClick={() => onEdit(entry)} // MODIFICATION: Appel à onEdit
    >
      <div className="flex justify-between items-start">
        <div>
          <h5 className="font-semibold text-sm text-gray-800">{entry.title}</h5>
          <div className="text-xs text-gray-500 mt-0.5 space-x-2 flex items-center">
             <span className="flex items-center" title={`Date de l'entrée: ${displayDate}`}>
                 <Calendar size={12} className="mr-0.5"/> {displayDate}
             </span>
             <span className="flex items-center" title={`Créé par: ${userName}`}>
                <User size={12} className="mr-0.5"/> {userName}
             </span>
          </div>
        </div>
        {/* MODIFICATION: Bouton Edit retiré, seul Supprimer reste */}
        <div className="flex space-x-1 flex-shrink-0">
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(entry.id); }} // Empêcher le clic de se propager à onEdit
            disabled={isDeleting === entry.id}
            className="p-1 text-red-500 hover:text-red-700 rounded-full hover:bg-red-50 disabled:opacity-50"
            title="Supprimer"
          >
            <Trash2 size={14} />
          </button>
        </div>
      </div>
      <div
        className="mt-2 text-xs text-gray-600 leading-relaxed"
        style={{
          wordBreak: 'break-word',
          display: '-webkit-box',
          WebkitLineClamp: 5,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden'
        }}
      >
        {previewText || 'Pas de contenu.'}
      </div>
      {entry.tags && entry.tags.length > 0 && (
        <div className="mt-1.5 flex flex-wrap gap-1">
          {entry.tags.map(tag => (
            <span key={tag} className="px-1.5 py-0.5 bg-gray-100 text-gray-700 rounded-full text-[10px] font-medium">
              {tag}
            </span>
          ))}
        </div>
      )}
    </li>
  );
};

export default JournalEntryListItem;
